import type { ZudokuConfig, ZudokuPlugin } from "zudoku";
import { analyticsPlugin } from "./plugins/analyticsPlugin";
import { jsonLdPlugin } from "./plugins/jsonLdPlugin";

const metadata: any = {
  title: "%s | Gamopanda",
  favicon: "/favicon.svg", // Favicon is broken in local mode due to bug in Zudoku where it does not work with basePath. In deployment it looks good.
};

const plugins: ZudokuPlugin[] = [jsonLdPlugin];

if (analyticsPlugin) {
  plugins.push(analyticsPlugin);
}

const config: ZudokuConfig = {
  port: 5175,
  metadata,
  plugins,
  basePath: '/docs',
  site: {
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" }, // Logo is broken in local mode due to bug in Zudoku where it does not work with basePath. In deployment it looks good.
      alt: "Gamopanda",
      width: "200px",
    },
  },
  theme: {
    light: {
      primary: "#7C3AED",
      primaryForeground: "#FFFFFF",
    },
    dark: {
      primary: "#7C3AED",
      primaryForeground: "#FFFFFF"
    },
  },
  canonicalUrlOrigin: "https://gamopanda.com",
  sitemap: {
    siteUrl: "https://gamopanda.com",
    changefreq: "daily",
    priority: 0.7,
    autoLastmod: true,
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      icon: "book",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          items: [
            '/introduction'
          ]
        },
        {
          type: "category",
          label: "Modules",
          icon: "layers",
          items: [
            "/modules-introduction",
            "/organization",
            "/account",
            "/member",
            "/streak",
            "/challenge",
            "/mission",
            "/milestone",
            "/reward",
            "/coupon",
            "/reward-log",
            "/streak-log",
            "/streak-progress",
            "/challenge-log",
            "/challenge-progress",
            "/mission-log",
            "/mission-progress",
            "/template",
            "/theme",
            "/floating-widget",
            "/email-header",
            "/email-footer",
            "/email-template",
            "/email-theme",
            "/push-notification-template",
            "/sms-template",
            "/whatsapp-template",
            "/aws-whatsapp",
            "/aws-sms",
            "/firebase-cloud-messaging",
            "/gamopanda-email",
            "/notification",
            "/notification-log",
            "/webhook",
            "/webhook-log",
            "/event-log",
            "/api-key",
          ],
        },
        {
          type: "category",
          label: "API",
          collapsible: true,
          icon: "code",
          items: [
            "/api-introduction",
            {
              type: "link",
              label: "API Reference",
              to: "/api",
            },
          ],
        },
        {
          type: "category",
          label: "End User Display",
          collapsible: true,
          icon: "tablet-smartphone",
          items: [
            "/end-user-display-introduction",
            "/javascript-integration",
            "/access-token",
          ],
        },
        {
          type: "category",
          label: "Integrations",
          collapsible: true,
          icon: "puzzle",
          items: [
            "/integrations-introduction",
            "/shopify",
            "/wix",
            "/mcp-server",
          ],
        }
      ],
    },
    {
      "type": "link",
      "to": "/api",
      "label": "API Reference",
      "icon": "code"
    },
    {
      "type": "link",
      "to": "/demo",
      "label": "Demo",
      "icon": "play"
    }
  ],
  redirects: [{ from: "/", to: "/introduction" }],
  apis: [
    {
      type: "url",
      input: `${process.env.ZUDOKU_PUBLIC_API_BASE_DOMAIN}/openapi`,
      path: "/api",
      options: {
        showInfoPage: true,
        schemaDownload: {
          enabled: true
        }
      }
    },
  ],
};

export default config;
